import React, { useState } from 'react';
import { Box, Grid, Modal } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RoundButton from './roundButton';
import { getWCSDomainBaseURL } from '../../services/config';

import { GetLangId } from '../../services/commonService';

const RequestQuoteModal = props => {
  const {
    open,
    sessionDataItems,
    quantity,
    cartResponse,
    miniQuoteCartResponse,
    productImage,
    handleClose
  } = props;

  const [showLogin, setShowLogin] = useState(false);

  const onQuoteClick = () => {
    setShowLogin(true);
  };

  const onCloseLoginModal = () => {
    setShowLogin(false);
  };

  const onViewCartClick = () => {
    window.location.href = `${getWCSDomainBaseURL()}/${sessionDataItems?.countryCode?.toLowerCase()}/${
      sessionDataItems?.language
    }/ViewQuote`;
  };

  const onContinueAsGuestClick = () => {
    window.location.href = `${getWCSDomainBaseURL()}/${sessionDataItems?.countryCode?.toLowerCase()}/${
      sessionDataItems?.language
    }/SubmitQuote`;
  };

  const onSignInAndContinueClick = () => {
    let btoaString = btoa(
      `${getWCSDomainBaseURL()}/${sessionDataItems?.countryCode?.toLowerCase()}/${
        sessionDataItems?.language
      }/SubmitQuote`
    );
    window.location.href = `${getWCSDomainBaseURL()}/SSOLoginPage?catalogId=14051&langId=${GetLangId(
      sessionDataItems.language
    )}&SSOURL=${btoaString}&storeId=${sessionDataItems?.storeId}`;
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box className="modal-common request-quote-modal">
        <Grid container className="request-quote">
          <Grid container className="heading-row">
            <Grid item xs={6} className="display-flex">
              <div>
                <CheckCircleIcon className="check-icon" />
              </div>
              <span className="check-icon-label">Item Added to Quote</span>
            </Grid>
            <Grid item xs={6} onClick={handleClose} className="align-right">
              <CloseRoundedIcon />
            </Grid>
          </Grid>

          <Grid item xs={12} container className="item-row">
            <Grid item xs={4}>
              <img className="request-quote-image" src={productImage} />
            </Grid>
            <Grid item xs={8}>
              <Grid container>
                <Grid item xs={12}>
                  <span className="series-name">
                    {sessionDataItems?.seriesName}
                  </span>
                </Grid>
                <Grid item xs={12} className="part-number">
                  Part #: {sessionDataItems.partNumber}
                </Grid>
                <Grid item xs={12} className="qty">
                  Qty: {quantity}
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={5.5}>
              <RoundButton
                name="View Cart"
                classname="black-button rfq-button"
                onClick={() => onViewCartClick()}
              />
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={5.5}>
              <RoundButton
                name="Complete Quote Request"
                classname="yellow-button rfq-button"
                disabled={showLogin}
                onClick={() => onQuoteClick()}
              />
            </Grid>
          </Grid>
          {showLogin && (
            <Grid item container className="login-section">
              <Grid container className="container">
                <Grid item xs={12} className="align-right">
                  <CloseRoundedIcon onClick={() => onCloseLoginModal()} />
                </Grid>
                <Grid item xs={12}>
                  <span className="please-select-label">
                    Please select one of the following.
                  </span>
                </Grid>
                <Grid item xs={5.5}>
                  <RoundButton
                    name="Continue as Guest"
                    classname="black-button rfq-button"
                    onClick={() => onContinueAsGuestClick()}
                  />
                </Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={5.5}>
                  <RoundButton
                    name="Sign In & Continue"
                    classname="yellow-button rfq-button"
                    onClick={() => onSignInAndContinueClick()}
                  />
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Box>
    </Modal>
  );
};

export default RequestQuoteModal;
